import { escapeHref } from '@paintscout/util'

export default function Signup() {
  // TODO: redirect to /free-trial instead
  window.location.href = escapeHref('https://www.paintscout.com/demo/')

  // const { auth0Client } = useAuth()

  // const urlParams = new URLSearchParams(window.location.search)
  // const source = urlParams.get('source')

  // auth0Client.loginWithRedirect({
  //   authorizationParams: {
  //     login_hint: 'signup',
  //     screen_hint: source,
  //     redirect_uri: `${process.env.PS_APP_URL}/login-callback`
  //   }
  // })

  return null
}
